import { Stack, Group, Title, Text, Box } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './FormSubsection.module.css';

interface FormSubsectionProps {
  title: ReactNode;
  description?: ReactNode;
  rightSection?: ReactNode;
  children: ReactNode;
}

/**
 * Inline subsection without card border, for stacking multiple labeled
 * sub-areas inside a single FormSection card.
 */
export function FormSubsection({
  title,
  description,
  rightSection,
  children,
}: FormSubsectionProps) {
  return (
    <Stack gap="md" className={classes.root}>
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={2}>
          <Title order={3} className={classes.title}>
            {title}
          </Title>
          {description && (
            <Text size="sm" c="vdzGray.6">
              {description}
            </Text>
          )}
        </Stack>
        {rightSection}
      </Group>
      <Box>{children}</Box>
    </Stack>
  );
}
